import { useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { motion } from "framer-motion";
import { toast } from "sonner";
import api, { formatApiError } from "../lib/api";

export default function ResetPasswordPage() {
  const [params] = useSearchParams();
  const token = params.get("token") || "";
  const navigate = useNavigate();
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    if (password !== confirm) { setError("Le password non coincidono"); return; }
    setLoading(true);
    try {
      await api.post("/auth/reset-password", { token, password });
      toast.success("Password aggiornata! Ora puoi accedere.");
      navigate("/login");
    } catch (err) {
      setError(formatApiError(err.response?.data?.detail) || err.message);
    } finally { setLoading(false); }
  };

  return (
    <div className="safe-pt grid min-h-screen place-items-center bg-cream px-6">
      <motion.div initial={{ opacity: 0, y: 16 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.6 }} className="w-full max-w-sm">
        <Link to="/" className="notranslate mb-8 block text-center font-serif text-4xl text-ink" translate="no">NEED</Link>
        <h1 className="font-serif text-3xl font-light text-ink">Nuova password</h1>
        <p className="mt-2 text-sm text-ink-soft">Scegli una nuova password per il tuo account.</p>
        {!token ? (
          <p className="mt-6 text-sm text-red-600" data-testid="reset-no-token">Link non valido. Richiedi un nuovo reset dalla pagina di accesso.</p>
        ) : (
          <form onSubmit={submit} className="mt-6 space-y-3">
            <input type="password" value={password} onChange={(e) => setPassword(e.target.value)} required minLength={6} placeholder="Nuova password" data-testid="reset-password" className="w-full rounded-xl border border-ink/15 bg-panel px-4 py-3 text-sm outline-none focus:border-sage" />
            <input type="password" value={confirm} onChange={(e) => setConfirm(e.target.value)} required minLength={6} placeholder="Conferma password" data-testid="reset-confirm" className="w-full rounded-xl border border-ink/15 bg-panel px-4 py-3 text-sm outline-none focus:border-sage" />
            {error && <p className="text-sm text-red-600" data-testid="reset-error">{error}</p>}
            <button type="submit" disabled={loading} data-testid="reset-submit" className="w-full rounded-full bg-ink py-3.5 text-sm font-semibold text-cream hover:bg-sage disabled:opacity-60">
              {loading ? "Attendi…" : "Aggiorna password"}
            </button>
          </form>
        )}
        <Link to="/login" className="mt-6 block text-center text-sm text-sage hover:underline">Torna all'accesso</Link>
      </motion.div>
    </div>
  );
}
